import { Tag, type TagColor, type TagSize } from "@/shared/components/ui/tag";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip";
import { Sparkles } from "lucide-react";
import { AnimatedShinyText } from "@/shared/components/ui/animated-shiny-text";

interface SourceDocument {
  id: number;
  file_name: string;
  display_name?: string | null;
  document_type?: string;
  created_at: string;
}

interface DocumentBadgeProps {
  sourceDocument: SourceDocument;
  variant: "short" | "long";
  onClick: () => void;
  color?: TagColor;
  size?: TagSize;
  shimmer?: boolean;
  className?: string;
  maxNameWidth?: string;
}

export function DocumentBadge({
  sourceDocument,
  variant,
  onClick,
  color = "green",
  size = "md",
  shimmer = true,
  className,
  maxNameWidth = "150px",
}: DocumentBadgeProps) {
  const isShort = variant === "short";
  const documentName = sourceDocument.display_name || sourceDocument.file_name;
  const label = isShort ? (
    "Auto"
  ) : (
    <span className="truncate" style={{ maxWidth: maxNameWidth }}>
      {documentName}
    </span>
  );

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span onClick={onClick} className="cursor-pointer">
            <Tag color={color} size={size} icon={Sparkles} className={className}>
              {shimmer ? <AnimatedShinyText>{label}</AnimatedShinyText> : label}
            </Tag>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-sm">Added from {documentName}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
